/** CLN PDP: append "Airport Lounge" to title only when the name does not already say airport lounge. */
export function shouldFormatClnAirportLoungeTitle(experience: {
  provider: string
  name: string
}): boolean {
  if (experience.provider !== 'cln') return false
  return !/airport\s+lounge/i.test(experience.name)
}
